import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import { getImageSrc } from "@web-monorepo/static-assets";
import { Student } from "src/pods/students";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/groups/assets/logo.svg");

export type Group = {
  students: Student[];
};

export const appMetadataGroups = (): AppMetadata => ({
  href: "groups",
  title: t`Group Maker`,
  variant: "groups",
  icon,
});

export type GroupsState = {
  baseAvatarURL: string | null;
  groups: Group[] | null;
  restrictions: unknown;
};

export const initialGroupsState: GroupsState = {
  baseAvatarURL: null,
  groups: null,
  restrictions: null,
};

export const SEND_GROUPS = createAction("SEND_GROUPS");
export const sendGroups = createActionCreator(SEND_GROUPS, (groups: Group[]) => ({ groups }));

export const RECEIVE_GROUPS = createAction("RECEIVE_GROUPS");
